/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Ordinal from '../../partials/Ordinal';

import styles from '../../../../styles/displays/slides/period.module.scss';

const propTypes = {
    period: PropTypes.string,
    quarter: PropTypes.bool,
};

const defaultProps = {
    period: null,
    quarter: false,
};

function PeriodSlide({ period, quarter }) {
    const themeClassName = useThemeClassName(styles);
    const displayedPeriod = parseInt(period, 10);
    return (
        <div className={classNames([styles.container, themeClassName])}>
            <div className={styles.period}>
                <span className={styles.number}>
                    <Ordinal number={displayedPeriod} feminine={!quarter} />
                </span>
                <span className={styles.label}>
                    {quarter ? (
                        <FormattedMessage defaultMessage="Quarter" description="Period label" />
                    ) : (
                        <FormattedMessage defaultMessage="Period" description="Period label" />
                    )}
                </span>
            </div>
            <h2 className={styles.title}>
                {quarter ? (
                    <FormattedMessage
                        defaultMessage="Complete your answers for the"
                        description="Ordinal quarter label"
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="Complete your answers for the"
                        description="Ordinal period label"
                    />
                )}{' '}
                <Ordinal number={displayedPeriod} feminine={!quarter} />{' '}
                {quarter ? (
                    <FormattedMessage
                        defaultMessage="quarter!"
                        description="Ordinal period label"
                    />
                ) : (
                    <FormattedMessage defaultMessage="period!" description="Ordinal period label" />
                )}
            </h2>
        </div>
    );
}

PeriodSlide.propTypes = propTypes;
PeriodSlide.defaultProps = defaultProps;

export default PeriodSlide;
